import { render } from "./bank-card-v2.html?vue&type=template&id=5ecc4537&scoped=true&ts=true&external"
import script from "./bank-card-v2.ts?vue&type=script&lang=ts&external"
export * from "./bank-card-v2.ts?vue&type=script&lang=ts&external"

import "./bank-card-v2.scss?vue&type=style&index=0&id=5ecc4537&scoped=true&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecc4537"]])

export default __exports__